import React from "react";

import './loader2.scss';

const Loader2 = () => {
    return(
        <div id="preloader">
            <div id="loader"></div>
        </div>
    )
} 

export default Loader2;